import { useEffect } from "react";
import { CSS_VARIABLE_PREFIX } from "../../constants/prefix";
import darkSkin from "./skins/darkSkin";
import lightSkin from "./skins/lightSkin";

const useThemeStyles = (skin) => {
  useEffect(() => {
    const prefix = CSS_VARIABLE_PREFIX;

    const headTag = document.getElementsByTagName("head")[0];
    const styleTag = document.createElement("style");
    styleTag.id = "gc-root-css-variables";

    const theme = skin === "dark" ? darkSkin : lightSkin;

    let cssVariables = `\n:root { \n`;

    Object.keys(theme).forEach((key) => {
      cssVariables += `  ${prefix}${key}: ${theme[key]};\n`;
    });

    cssVariables += `}\n`;

    styleTag.innerHTML = cssVariables;

    headTag.appendChild(styleTag);

    return () => {
      // Cleanup logic, remove the style tag on unmount
      headTag.removeChild(styleTag);
    };
  }, [skin]);
};

export default useThemeStyles;
